export const auxEnfermagem = {
  nome: 'Aux/Téc Enfermagem',
  id_perfil: 6,
  dashboard: [
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
      featured: true,
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
      featured: true,
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/atendimentos-no-mes/profissional',
      titulo: 'Relatório atendimentos',
      icone: 'icofont-list',
      key: 'atendimentos_no_mes',
    },
    {
      link: '/imunizacao',
      titulo: 'Imunização',
      icone: false,
      imagem: require('@/assets/icones/imunizacao.png'),
      key: 'imunizacao',
    },
    {
      link: '/saude-crianca',
      titulo: 'Saúde criança',
      icone: false,
      imagem: '',
      svg: 'SaudeCrianca',
      key: 'saude_crianca',
    },
    {
      link: '/aedes-aegypti/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
    {
      link: '/pos-covid-19/acs',
      titulo: 'Pós Covid-19',
      icone: false,
      imagem: '',
      svg: 'PosCovid19',
      key: 'pos_covid_19',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/acs-por-cidadao',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
    },
    {
      link: '/calculadora-de-pessoas/equipe',
      titulo: 'Calculadora de pessoas',
      icone: 'icofont-ui-calculator',
      key: 'calculadora_de_pessoas',
    },
    {
      link: '/obitos/profissional',
      titulo: 'Óbitos',
      icone: 'icofont-list',
      key: 'obitos',
    },
    {
      link: '/mudanca_territorio/profissional',
      titulo: 'Mudança de Território',
      icone: 'icofont-list',
      key: 'mudanca_territorio',
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [
    {
      link: '/vacina-idade-certa',
      titulo: 'Vacina idade certa',
      icone: false,
      imagem: require('@/assets/icones/situacao_vacinal.png'),
      key: 'vacina_idade_certa',
    },
    {
      link: '/campanha-gripe/equipe',
      titulo: 'Campanha gripe',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/campanha-gripe.png'),
      key: 'campanha_gripe',
    },
    {
      link: '/divergencias-vacinas',
      titulo: 'Divergências vacinas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/inconsistencias.png'),
      key: 'divergencia_vacinas',
    },
    {
      link: '/dose-imunizante/equipe/acs',
      titulo: 'Dose Imunizante',
      icone: 'icofont-injection-syringe',
      key: 'dose_imunizante',
    },
  ],
  vacina_idade_certa: [
    {
      link: '/faltosos-vacinas-0-15-anos/equipe/acs',
      titulo: '0 - 15 anos',
      icone: false,
      imagem: require('@/assets/icones/2anos.png'),
      key: 'faltosos_2_anos',
    },
    {
      link: '/hpv-quadrivalente/equipe/acs',
      titulo: 'HPV quadrivalente',
      icone: false,
      imagem: require('@/assets/icones/hpv.png'),
      key: 'hpv_quadrivalente',
    },
    {
      link: '/acwy/equipe/acs',
      titulo: 'Meningocócica ACWY',
      icone: false,
      imagem: require('@/assets/icones/acwy.png'),
      key: 'meningococica_acwy',
    },
    {
      link: '/covid19-infantil/equipe/acs',
      titulo: 'COVID-19 Infantil',
      icone: false,
      imagem: '',
      svg: 'Covid19Infantil',
      key: 'covid19_infantil',
    },
    {
      link: '/criancas-dtp-em-atraso/equipe/acs',
      titulo: 'DTP',
      icone: false,
      imagem: '',
      svg: 'Dtp',
      key: 'criancas_dtp_em_atraso',
    },
    {
      link: '/pneumococica-10v/equipe/acs',
      titulo: 'Pneumocócica 10V (conjugada)',
      icone: false,
      imagem: '',
      svg: 'Pneumo',
      key: 'pneumococica_10V',
    },
    {
      link: '/triplice-viral/equipe/acs',
      titulo: 'Tríplice viral',
      icone: false,
      imagem: '',
      svg: 'TripleceViral',
      key: 'triplice_viral',
    },
    {
      link: '/varicela/equipe/acs',
      titulo: 'Varicela',
      icone: false,
      imagem: '',
      svg: 'Varicela',
      key: 'varicela',
    },
    {
      link: '/tetra-viral/equipe/acs',
      titulo: 'Tetra viral',
      icone: 'icofont-injection-syringe',
      key: 'tetra_viral',
    },
    {
      link: '/vacina-dengue/equipe/acs',
      titulo: 'Vacina Dengue',
      icone: 'icofont-injection-syringe',
      key: 'vacina_dengue',
    },
  ],
  divergencia_vacinas: [
    {
      link: '/divergencias-vacinas/vacinas-nao-enviadas/equipe/acs',
      titulo: 'Vacinas não enviadas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_nao_enviadas.png'),
      key: 'vacinas_nao_enviadas',
    },
    {
      link: '/divergencias-vacinas/d3-antes-6/equipe/acs',
      titulo: 'D3 antes 6 meses',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/D3.png'),
      key: 'd3_antes_6_meses',
    },
    {
      link: '/divergencias-vacinas/vacinas-nascimento-divergente/equipe/acs',
      titulo: 'Vacinas nascimento divergente',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_nascimento_divergente',
    },
    {
      link: '/divergencias-vacinas/vacinas-sem-cadastro/equipe/acs',
      titulo: 'Vacinas sem cadastro',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_sem_cadastro.png'),
      key: 'vacinas_sem_cadastro',
    },
    {
      link: '/divergencias-vacinas/vacinas-antes-nascimento/equipe/acs',
      titulo: 'Vacinas antes nascimento',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_antes_nascimento',
    },
  ],
  indicadores_aps: [
    {
      link: '/indicador-citologico/profissional',
      titulo: 'Exames Citopatológico',
      icone: 'icofont-stretcher',
      key: 'citopatologico',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicador-imunizacao/equipe/acs',
      titulo: 'Desenvolvimento infantil',
      icone: 'icofont-baby',
      key: 'vacinas_polio_penta',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pre-natal',
      titulo: 'Gestantes e Puérperas',
      icone: false,
      imagem: require('@/assets/images/pregnant.png'),
      key: 'pre_natal',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/doencas-cronicas',
      titulo: 'Doenças crônicas',
      icone: 'icofont-drug',
      key: 'doencas_cronicas',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/saude-da-mulher',
      titulo: 'Saúde da mulher',
      icone: 'icofont-female',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: 'icofont-drug',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/primeira-consulta-programada',
      titulo: '1ª Consulta programada',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/proporcao-procedimentos-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-art',
      titulo: 'Tratamento restaurador',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/cuidado-compartilhado',
      titulo: 'Cuidado compartilhado',
      icone: 'icofont-duotone icofont-field-group',
      key: 'cuidado_compartilhado',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: 'icofont-duotone icofont-field-group',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/comunicacao-emulti-e-equipes',
      titulo: 'Comunicação',
      icone: 'icofont-ui-chat',
      key: 'comunicacao_emulti_equipes',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resolutividade-cuidado-emulti',
      titulo: 'Resolutividade',
      icone: 'icofont-duotone icofont-field-group',
      key: 'resolutividade_cuidado_emulti',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/cuidado-compartilhado',
      titulo: 'Cuidado compartilhado',
      icone: 'icofont-duotone icofont-field-group',
      key: 'cuidado_compartilhado',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: 'icofont-duotone icofont-field-group',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/comunicacao-emulti-e-equipes',
      titulo: 'Comunicação',
      icone: 'icofont-ui-chat',
      key: 'comunicacao_emulti_equipes',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resolutividade-cuidado-emulti',
      titulo: 'Resolutividade',
      icone: 'icofont-duotone icofont-field-group',
      key: 'resolutividade_cuidado_emulti',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resultado-isf-acs',
      titulo: 'Resultado ISF',
      icone: false,
      imagem: '',
      svg: 'ResultadoIsf',
      key: 'resultado_isf',
    },
    // {
    //   link: '/resultado-indicadores',
    //   titulo: 'Resultado Indicadores',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ResultadoIndicadores',
    //   key: 'resultado_indicadores',
    // },
    {
      link: '/desempenho-por-equipe',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'desempenho_por_equipe',
    },
  ],
  pre_natal: [
    {
      link: '/consultas-pre-natal/profissional',
      titulo: 'Consultas pré-natal',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'consultas_pre_natal',
    },
    {
      link: '/consultas-odontologicas/profissional',
      titulo: 'Consultas odontológicas',
      icone: false,
      imagem: '',
      svg: 'ConsultasOdontologicas',
      key: 'consultas_odontologicas',
    },
    {
      link: '/exames-hiv-sifilis/profissional',
      titulo: 'Exames HIV e Sífilis',
      icone: false,
      imagem: '',
      svg: 'ExamesHivSifilis',
      key: 'hiv_sifilis',
    },
    {
      link: '/tres-indicadores-pre-natal/equipe/acs',
      titulo: 'Os 3 Indicadores Pré-natal',
      icone: false,
      imagem: '',
      svg: 'TresIndicadoresPreNatal',
      key: 'tres_indicadores_pre_natal',
    },
  ],
  doencas_cronicas: [
    {
      link: '/hemoglobina-glicada/profissional',
      titulo: 'Atendimento diabetes',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDiabetes',
      key: 'atendimento_diabetes',
    },
    {
      link: '/atendimento-hipertensao/profissional',
      titulo: 'Atendimento Hipertensão',
      icone: false,
      imagem: '',
      svg: 'AtendimentoHipertensao',
      key: 'atendimento_hipertensao',
    },
    {
      link: '/hiper-dia/profissional',
      titulo: 'Atendimento HiperDia',
      icone: false,
      imagem: '',
      svg: 'HiperDia',
      key: 'atendimento_hiper_dia',
    },
  ],
  desempenho_por_equipe: [
    {
      link: '/desempenho-por-equipe/indicador',
      titulo: 'Desempenho por Indicador',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_por_indicador',
    },
    {
      link: '/desempenho-por-equipe/geral',
      titulo: 'Desempenho Geral',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_geral',
    },
  ],
  saude_crianca: [
    {
      link: '/teste-pezinho',
      titulo: 'Teste do pezinho',
      icone: 'icofont-foot-print',
      key: 'teste_pezinho',
    },
  ],
  indicadores_esb: [],
  indicadores_esb_estrategicos: [],
  indicadores_esb_ampliados: [],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento/profissional',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
  ],
  bpa_e_ras: [],
}
